import React from 'react';

import polyline from '@mapbox/polyline';
import BaseMap from './BaseMap';
import { defaultLineStyle, defaultPointStyle, defaultSymbolStyle } from './BaseMapStyles';

// let test_polyline = "ynyuEjfdlNn@kAa@e@Xc@JSlB}CXe@FKBEf@w@Za@HKFELM\\U`@SPGTGvBa@lAWd@ITGFEJGBCVUHKFOHOPc@\\{@HQTKl@uARe@WOMKi@[{@k@KIOKMKkBoAoAaAe@c@c@c@eAsAm@cAe@eAU]_@m@[e@AC]g@EGIMSWIIQOYYGGOOWSIIuEoEe@a@o@q@]a@SYU[QYW_@u@kAUa@u@_AKMi@k@u@o@[SOI}@m@gBu@}Bw@]OaBm@mDsAeDsAEA}QaHECGCGAGCUI]OcA_@qBs@_A]SGQGa@MICOEcA[QFs@UeBg@kA]ICOEmBg@QEa@M_@KMEgCw@[W]KUGy@Se@MWG}@K}@Gg@?a@Ai@?G?GAO?SAAZEXCt@Cl@EpAAb@EtA?\\AnA?D?LADGlBKvCElAQbECv@APEz@C^CVOzAKHOnASbBGd@Kv@@^i@zDO|AAN?FCLANIv@C^KbAI|@MdAE`@G`@CJOt@ABOn@K^Of@Kb@Ql@Md@Mb@]rAMb@IXMd@Qn@Mf@W`Aa@`BS|@GXGVIZCHi@zBAFENIj@Gn@AXAPAFGzA?HE`AEp@EbAE`AM?aADg@BiFTuI\\M?WI}KyB_B[m@lFo@lFYEaKsBaASeAS_BYYC?GAGEOOULQDIBEFSHk@BO?C??"

class BasicPointMap extends React.Component {
  constructor(props) {
    super(props);
  }

  encodePoints = (points) => {
    return {
      type: 'FeatureCollection',
      features: points.map((site) => {
        return {
          type: 'Feature',
          id: site.id,
          geometry: {
            type: 'Point',
            coordinates: [+site.lon || +site.longitude || 0, +site.lat || +site.longitude || 0],
          },
          properties: {
            label: site.name,
            data: site,
            iconName:
              this.props.requiredIcons &&
              this.props.requiredIcons[site.group % this.props.requiredIcons.length].iconName,
            iconColor: site.color,
            disabled: false,
          },
        };
      }),
    };
  };

  render() {
    return (
      <div className={'pointMap'}>
        <BaseMap
          static
          requiredIcons={this.props.requiredIcons}
          sources={[
            this.props.requiredIcons
              ? {
                  id: 'points',
                  type: 'geojson',
                  data: this.encodePoints(this.props.features),
                  style: defaultSymbolStyle,
                  isInteractive: false,
                }
              : {
                  id: 'points',
                  type: 'geojson',
                  data: this.encodePoints(this.props.features),
                  style: defaultPointStyle,
                  isInteractive: false,
                },
            this.props.polyline && {
              id: 'line',
              type: 'geojson',
              data: polyline && polyline.toGeoJSON(this.props.polyline),
              style: defaultLineStyle,
              isInteractive: false,
            },
          ].filter((n) => n)}
        />
      </div>
    );
  }
}

export default BasicPointMap;
